import React from 'react';
import PropTypes from 'prop-types';
import { Select as TWSelect, SelectMulti } from 'twyne-new.ui'

import { useProps, useClassName } from 'components/pure/hooks';

const propTypes = TWSelect.propTypes
const imutableProps = {}
const mutableProps = {}

const classNames = {}

export default function Select({ children, className, ...props }) {
  className = useClassName(classNames, className)

  const Component = props.isMulti ? SelectMulti : TWSelect
  return <Component {...useProps(props, imutableProps)} className={className} children={children} />
}

Select.propTypes = propTypes
Select.defaultProps = mutableProps